import type { SystemIconId } from '@volvo/vcdk-assets';

export interface ParsedFleetName {
  icon: SystemIconId;
  fleetName: string;
}

/**
 * Parses a fleet name string that may contain an icon prefix.
 * Expected format: `::${icon}::${fleetName}`
 *
 * @param value - The fleet name string to parse
 * @returns An object containing the icon and fleetName
 *
 * @example
 * parseFleetName('::boat::My Fleet') // { icon: 'boat', fleetName: 'My Fleet' }
 * parseFleetName('My Fleet') // { icon: 'vessel', fleetName: 'My Fleet' }
 */
export function parseFleetName(value: string): ParsedFleetName {
  const regex = /^::([^:]+)::(.+)$/;
  const match = value.match(regex);

  if (match) {
    return {
      icon: match[1] as SystemIconId,
      fleetName: match[2],
    };
  }

  return {
    icon: 'vessel',
    fleetName: value,
  };
}
